import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { FormElementControlPropsType, FormControlProps } from './index';
import { FormComponentBuilder } from 'components/common/form/layout';

export interface FormControlLlmModelNameFieldProps extends FormControlProps {
    watchFields: string[];
    apiTypeLabels: Record<string, string>;
    nameField: string;
}

export default function LlmModelNameField({
    controlProps,
}: FormElementControlPropsType<FormControlLlmModelNameFieldProps>) {
    const { watchFields, apiTypeLabels, nameField } = controlProps;

    const apiType = useWatch({ control: controlProps.form.hookFormControl, name: watchFields[0] });
    const model = useWatch({ control: controlProps.form.hookFormControl, name: watchFields[1] });

    const [currentGenState, setCurrentGenState] = useState<string>();
    useEffect(() => {
        const label = apiTypeLabels[apiType] ?? apiType ?? '';
        const derived = [label, model].filter(Boolean).join(' ').trim();
        const currentName = controlProps.form.hookFormGetValues(nameField) ?? '';
        if (currentGenState != undefined) {
            if (currentName == currentGenState || currentName.trim() == '') {
                controlProps.form.hookFormSetValue(nameField, derived);
            }
        }
        setCurrentGenState(derived);
    }, [apiType, model]);

    return null;
}

export class LlmModelNameFieldBuilder extends FormComponentBuilder {
    prepareProps(): FormControlLlmModelNameFieldProps {
        return {
            ...this.controlProps,
            watchFields: this.elementProps.componentProps?.watchFields ?? [],
            apiTypeLabels: this.elementProps.componentProps?.apiTypeLabels ?? {},
            nameField: this.elementProps.componentProps?.nameField ?? 'name',
        };
    }
}
